import * as styles from "@/client/core/components/web-auth-gate.css";
import { createEl } from "@/client/utils/createEl";

/**
 * Full-viewport login gate shown when the website requires an interactive
 * Splice login. Covers whatever app UI rendered underneath; the server's
 * auth hook remains the actual enforcement layer.
 */
export const showWebAuthGate = (onLogInClick: () => void): void => {
    const title = createEl("h1", styles.title, "Backstage");
    const message = createEl("p", styles.message, "Log in with your Splice account to continue.");
    const button = createEl("button", styles.button, "Log in with Splice", (el) => {
        el.addEventListener("click", () => {
            el.disabled = true;
            onLogInClick();
        });
    });
    const card = createEl("div", styles.card, [title, message, button]);
    const overlay = createEl("div", styles.overlay, [card]);
    document.body.append(overlay);
};
